module.exports = __webpack_public_path__ + "static/media/resume.b6cc2971.svg";